import type { CustomGlyphProps } from '@atlaskit/icon/types';
import Icon from '@atlaskit/icon';
import { R300 } from '@atlaskit/theme/colors';

const PriorityCritical24Glyph = (props: CustomGlyphProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={props['data-testid']}
    className={props.className}
  >
    <path
      d="M11.3753 4.21913L6.3753 8.21913C6.13809 8.4089 6 8.69622 6 9V19L6.00589 19.112C6.08752 19.8788 6.99969 20.2809 7.6247 19.7809L12 16.28L16.3753 19.7809C17.0301 20.3047 18 19.8385 18 19V9C18 8.69622 17.8619 8.4089 17.6247 8.21913L12.6247 4.21913C12.2595 3.92696 11.7405 3.92696 11.3753 4.21913Z"
      fill={R300}
    />
  </svg>
);

export const PriorityCritical24Icon = ({ label }: { label: string }) => {
  return <Icon glyph={PriorityCritical24Glyph} label={label} />;
};
